import { Container, Title, Text, Stack, Card, Group, ThemeIcon, Anchor } from '@mantine/core';
import { IconMail, IconBrandLinkedin, IconMessageCircle } from '@tabler/icons-react';
import { Layout } from '../shared/components/Layout';
import { useSEO } from '../shared/hooks';

export function Contact() {
  useSEO({
    title: 'Kontakt',
    description: 'Skontaktuj się z Taryfy Pradu. Pomoc techniczna, pytania o taryfy energetyczne, RODO. Email: kontakt@taryfypradu.pl',
    canonicalPath: '/kontakt',
  });
  return (
    <Layout isAuthenticated={false}>
      <Container size="md" py={80}>
        <Stack gap="xl">
          {/* Header */}
          <div>
            <Title order={1} mb="md">
              Kontakt
            </Title>
            <Text size="lg" c="dimmed">
              Masz pytania lub sugestie? Skontaktuj się z nami - chętnie pomożemy!
            </Text>
          </div>

          {/* Business Information */}
          <Card shadow="sm" padding="xl" radius="md" withBorder style={{ backgroundColor: 'var(--mantine-color-ecoGreen-0)' }}>
            <Stack gap="xs">
              <Text fw={700} size="lg" mb="xs">
                Robert Boguszewski
              </Text>
              <Text c="dimmed">
                ul. Królowej Jadwigi 34a
              </Text>
              <Text c="dimmed">
                32-040 Świątniki Górne
              </Text>
              <Text c="dimmed" mt="xs">
                <strong>NIP:</strong> 944-203-67-90
              </Text>
              <Text c="dimmed">
                <strong>REGON:</strong> 362403341
              </Text>
            </Stack>
          </Card>

          {/* Contact Methods */}
          <Card shadow="sm" padding="xl" radius="md" withBorder>
            <Stack gap="xl">
              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={48} radius="md" color="ecoGreen">
                  <IconMail size={24} />
                </ThemeIcon>
                <div>
                  <Text fw={600} size="lg" mb="xs">
                    Email - Sprawy ogólne
                  </Text>
                  <Text c="dimmed" mb="xs">
                    Napisz do nas w każdej sprawie dotyczącej platformy, taryf energetycznych
                    lub Twojego konta.
                  </Text>
                  <Anchor href="mailto:kontakt@taryfypradu.pl" size="lg" fw={500}>
                    kontakt@taryfypradu.pl
                  </Anchor>
                </div>
              </Group>

              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={48} radius="md" color="ecoGreen">
                  <IconMail size={24} />
                </ThemeIcon>
                <div>
                  <Text fw={600} size="lg" mb="xs">
                    Email - Pomoc techniczna
                  </Text>
                  <Text c="dimmed" mb="xs">
                    Potrzebujesz pomocy technicznej? Zgłoś problem lub zadaj pytanie dotyczące
                    funkcjonowania platformy.
                  </Text>
                  <Anchor href="mailto:pomoc@taryfypradu.pl" size="lg" fw={500}>
                    pomoc@taryfypradu.pl
                  </Anchor>
                </div>
              </Group>

              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={48} radius="md" color="ecoGreen">
                  <IconMail size={24} />
                </ThemeIcon>
                <div>
                  <Text fw={600} size="lg" mb="xs">
                    Email - RODO i prywatność
                  </Text>
                  <Text c="dimmed" mb="xs">
                    Pytania dotyczące ochrony danych osobowych, prywatności, lub chcesz skorzystać
                    ze swoich praw wynikających z RODO.
                  </Text>
                  <Anchor href="mailto:rodo@taryfypradu.pl" size="lg" fw={500}>
                    rodo@taryfypradu.pl
                  </Anchor>
                </div>
              </Group>

              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={48} radius="md" color="ecoGreen">
                  <IconMessageCircle size={24} />
                </ThemeIcon>
                <div>
                  <Text fw={600} size="lg" mb="xs">
                    Centrum pomocy
                  </Text>
                  <Text c="dimmed" mb="xs">
                    Sprawdź naszą sekcję FAQ, gdzie znajdziesz odpowiedzi na najczęściej
                    zadawane pytania.
                  </Text>
                  <Anchor href="/faq" size="lg" fw={500}>
                    Przejdź do FAQ
                  </Anchor>
                </div>
              </Group>

              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon size={48} radius="md" color="ecoGreen">
                  <IconBrandLinkedin size={24} />
                </ThemeIcon>
                <div>
                  <Text fw={600} size="lg" mb="xs">
                    Media społecznościowe
                  </Text>
                  <Text c="dimmed" mb="xs">
                    Śledź nas, aby być na bieżąco z najnowszymi informacjami o taryfach
                    energetycznych i zmianach na rynku energii.
                  </Text>
                  <Text size="sm" c="dimmed">
                    Wkrótce dostępne
                  </Text>
                </div>
              </Group>
            </Stack>
          </Card>

          {/* Response Time */}
          <Card padding="lg" radius="md" style={{ backgroundColor: 'var(--mantine-color-ecoGreen-0)' }}>
            <Text fw={600} mb="xs">
              Czas odpowiedzi
            </Text>
            <Text size="sm" c="dimmed">
              Staramy się odpowiadać na wszystkie wiadomości w ciągu 24-48 godzin w dni robocze.
              W weekendy i święta czas odpowiedzi może być dłuższy.
            </Text>
          </Card>
        </Stack>
      </Container>
    </Layout>
  );
}
